module.exports = __webpack_public_path__ + "img/IMG_20160717_153910_HDR .dd31cc80.jpg";